import {} from "./Report.js";
export function createReportEntry(error) {
    if (error instanceof Error) {
        return {
            message: error.message,
        };
    }
    else {
        return {
            message: String(error),
        };
    }
}
//# sourceMappingURL=createReportEntry.js.map